import { render } from "./pageGrid.vue?vue&type=template&id=e630f278&scoped=true"
import script from "./pageGrid.vue?vue&type=script&lang=js"
export * from "./pageGrid.vue?vue&type=script&lang=js"

import "./pageGrid.vue?vue&type=style&index=0&id=e630f278&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e630f278"]])

export default __exports__